import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formatear fecha SIN conversión de timezone
 * MySQL guarda en hora Argentina, no queremos que JS lo interprete como UTC
 * @param {string} dateStr - Fecha en formato ISO (2026-08-12T19:00:00)
 * @param {object} options - Opciones de formato
 * @param {boolean} options.showTime - Mostrar hora (default: true)
 * @param {boolean} options.showSeconds - Mostrar segundos (default: false)
 * @returns {string} Fecha formateada (12/08/2026 19:00)
 */
export const formatDateARG = (dateStr, options = {}) => {
  if (!dateStr) return '-';
  
  const { showTime = true, showSeconds = false } = options;
  
  try {
    // Separar fecha y hora sin usar new Date() para evitar conversión de timezone
    const [datePart, timePart] = dateStr.split('T');
    if (!datePart) return '-';
    
    const [year, month, day] = datePart.split('-');
    
    let result = `${day}/${month}/${year}`;
    
    if (showTime && timePart) {
      const timeParts = timePart.replace('Z', '').split(':');
      const hour = timeParts[0] || '00';
      const min = timeParts[1] || '00';
      const sec = timeParts[2]?.split('.')[0] || '00';
      
      result += showSeconds ? ` ${hour}:${min}:${sec}` : ` ${hour}:${min}`;
    }
    
    return result;
  } catch (e) {
    return dateStr; // Si falla, devolver original
  }
};

/**
 * Formatear solo fecha (sin hora)
 */
export const formatDateOnlyARG = (dateStr) => {
  return formatDateARG(dateStr, { showTime: false });
};
